import axios from "axios";
const BASE_URL = process.env.REACT_APP_DEV_URL;

export const getAllProductsGraphQL = async (token, page, search) => {
  const url = `${BASE_URL}/graphql/`;

  const data = {
    query:
      `query SearchProducts($search: String, $page: Int, $page_size: Int) { search_products(search: $search, page: $page, page_size: $page_size) { count next previous results { product_id product_design_number { design_no } brand_name brand_acronym subcategory_name, main_category_name rate_diary_entries { design_rate } product_name image_url fabric pcs_in_set status in_stock assorted assorted_pcs_in_set  } } }`,
    variables: { search: search, page: page, page_size: 10 },
  };

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getAllOrdersGraphQL = async (token, page, search, type) => {
  const url = `${BASE_URL}/graphql/`;

  const data = {
    query:
      `query search_orders($search: String, $page: Int, $page_size: Int, $placed_code: String) { search_orders(search: $search, page: $page, page_size: $page_size, placed_code: $placed_code) { count next previous results { order_id retailer agent_name address created_at status total_amount final_amount billing_address delivery_address discount_amount placed_code delivered_at } } }`,
    variables: { search: search, page: page, page_size: 10, placed_code: type },
  };

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getAllOrdersTypeGraphQL = async (token, page, search, type) => {
  const url = `${BASE_URL}/graphql/`;

  const data = {
    query:
    `query search_orders($search: String, $page: Int, $page_size: Int, $placed_code: String, $order_status: String) { search_orders(search: $search, page: $page, page_size: $page_size, placed_code: $placed_code,order_status: $order_status) { count next previous results { order_id retailer address created_at status total_amount final_amount billing_address delivery_address discount_amount placed_code delivered_at} } }`,
    variables: { search: search, page: page, page_size: 10, order_status: type },
  };

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getAllBrandsGraphQL = async (token, page, search) => {
  const url = `${BASE_URL}/graphql/`;

  const data = {
    query:
      `query search_brands($search: String, $page: Int, $page_size: Int) { search_brands(search: $search, page: $page, page_size: $page_size) { count next previous results { brand_id brand_name acronym image brand_image_url status in_stock description} } }`,
    variables: { search: search, page: page, page_size: 10 },
  };

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getAllSubCategoriesGraphQL = async (token, page, search) => {
  const url = `${BASE_URL}/graphql/`;

  const data = {
    query:
    `query search_subcategories($search: String, $page: Int, $page_size: Int) { search_subcategories(search: $search, page: $page, page_size: $page_size) { count next previous results { sub_category_id sub_category_name image sub_category_image_url status created_at description main_category { category_id category_name } } } }`,
    variables: { search: search, page: page, page_size: 10 },
  };

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getAllRetailersGraphQL = async (token, page, search, type) => {
  const url = `${BASE_URL}/graphql/`;

  const data = {
    query:
    `query getCustomeUsers($search: String, $page: Int = 1, $page_size: Int = 10, $user: String) { custome_users(search: $search, page: $page, page_size: $page_size, user: $user) { count next previous results { customer_id email mobile_number shop_name status owner_name fullname agent_name mobile_number total_orders total_sales} } }`,
    variables: { search: search, page: page, page_size: 10, user: type },
  };

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getAllWalletsGraphQL = async (token, page, search) => {
  const url = `${BASE_URL}/graphql/`;

  const data = {
    query:
    `query getCustomeUsers($search: String, $page: Int = 1, $page_size: Int = 10, $user: String, $my_retailer: Boolean) { custome_users(search: $search, page: $page, page_size: $page_size, user: $user,my_retailer: $my_retailer) { count next previous results { customer_id email mobile_number shop_name status owner_name fullname mobile_number total_orders total_sales credit_amount wallet_created_at} } }`,
    variables: { search: search, page: page, page_size: 10, my_retailer: true },
  };

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getAllRateDiaryGraphQL = async (token, page, search) => {
  const url = `${BASE_URL}/graphql/`;
  // console.log(token);
  

  const data = {
    query:
    `query search_rate_diary($search: String, $page: Int, $page_size: Int) { search_rate_diary(search: $search, page: $page, page_size: $page_size) { count next previous results { design_id brand_name product_name design_rate stock instock size_name colors product_design_number barcode_date rate_diary_id } } }`,
    variables: { search: search, page: page, page_size: 10 },
  };

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};